import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import HomePage from "./pages/HomePage";
import AppLayout from "./AppLayout";
import Dashboard from "./pages/Dashboard";
import Favorites from "./pages/Favorites";
import CompareCompanies from "./pages/CompareCompanies";
import AuthPage from "./pages/AuthPage";
import Subscribe from "./pages/Subscribe";
import { AuthProvider } from "./AuthContext";
import MarketOverviewPage from "./pages/MarketOverviewPage";
import ValuationModelsPage from "./pages/ValuationModelsPage";
import ReportsPage from "./pages/ReportsPage";
import EducationPage from "./pages/EducationPage";
import ModelPortfoliosPage from "./pages/ModelPortfoliosPage";
import CompanySpotlightPage from "./pages/CompanySpotlightPage";
import ContactPage from "./pages/ContactPage";
import Profile from "./pages/Profile";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/subscribe" element={<Subscribe />} /> {/* ✅ Moved out */}

          <Route path="/" element={<AppLayout />}>
            <Route index element={<HomePage />} />
            <Route path="home" element={<HomePage />} /> 
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="favorites" element={<Favorites />} />
            <Route path="compare-companies" element={<CompareCompanies />} />
            <Route path="*" element={<Navigate to="/home" />} />
            <Route path="/market-overview" element={<MarketOverviewPage />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/valuation-models" element={<ValuationModelsPage />} />
            <Route path="/reports" element={<ReportsPage />} />
            <Route path="/education" element={<EducationPage />} />
            <Route path="/portfolios" element={<ModelPortfoliosPage />} />
            <Route path="/company-spotlight" element={<CompanySpotlightPage />} />
            <Route path="/" element={<Navigate to="/home" replace />} />
            <Route path="/contact" element={<ContactPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
